<template>
    <div class="answer" @click="handleAnswer()">
        <div class="icon">
            <img :src="icon" :alt="answer.icon">
        </div>
        <div class="label">
            {{ answer.answer }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'Answer',
    props: {
        answer: Object
    },
    data () {
        return {
            publicPath: process.env.BASE_URL
        }
    },
    computed: {
        icon () {
            return `${this.publicPath}img/${this.answer.icon}.svg`
        }
    },
    methods: {
        handleAnswer () {
            this.$emit('handleAnswer', this.answer.code)
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '@/assets/scss/main.scss';

    .answer {
        width: 100%;
        margin: 0 0 16px 0;
        text-align: center;
        cursor: pointer;

        @include bp-lg {
            width: 33%;
            margin: 0;
        }

        .icon {
            width: 64px;
            height: 64px;
            margin: 16px auto;
            opacity: 0.8;
            @include transition-out();

            img {
                width: 100%;
                height: 100%;
            }

            @include bp-sm {
                width: 112px;
                height: 112px;
                margin: 32px auto;
            }

            @include bp-lg {
                width: 160px;
                height: 160px;
                margin: 32px auto;
            }
        }

        .label {
            width: 100%;
            margin: 0 auto;
            font-size: 20px;
            text-align: center;
            opacity: 0.8;
            @include transition-out();

            @include bp-lg {
                width: 90%;
                font-size: 32px;
            }

        }

        &:hover {
            .icon {
                opacity: 1;
                transform: scale(1.1, 1.1);
                @include transition-in();
            }

            .label {
                opacity: 1;
                transform: scale(1.1, 1.1);
                @include transition-in();
            }
        }
    }

</style>
